import { list49200Sprint01 } from '../ActivityLists/AL49200Sprint01'
import { se_1_1of4_PAaA, se_1_2of4_PAaA, xyz_1_1of4 } from './SL44000Sprint01TTR'
import { tLab } from './SL00000Sprint00'
import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'

// Software Systems Capstone (SSC) sprint 1 values.
const sprint = 1
const activityList = () => { return list49200Sprint01(sprint) }

const ssc_1_1of4 = () => { return xyz_1_1of4(sprint, activityList, se_1_1of4_PAaA, se_1_2of4_PAaA) }
const ssc_1_2of4 = () => { return [ renderCalendar, renderFinalExamTimes ] }
const ssc_1_3of4 = () => { return [ tLab ] }
const ssc_1_4of4 = () => { return [ renderCalendar, renderFinalExamTimes ] }

export const ssc_1_slidedeckTTR = [ ssc_1_1of4, ssc_1_2of4, ssc_1_3of4, ssc_1_4of4 ]